import { HttpParams } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from '../../../../../shared/services/commom.service';
import { EncriptyUtilService } from '../../../../../shared/services/encripty-util.service';
import { ImportarArquivoFuncionarioService } from './importar-arquivo-funcionario.service';
import { ModalImportarArquivoFuncionarioComponent } from './modal-importar-arquivo-funcionario/modal-importar-arquivo-funcionario.component';
import { NbDialogService } from '@nebular/theme';

interface ISendMailRegisterEmployee {
  partnerId: string;
  filename: string;
  content: string;
  subject: string;
}

@Component({
  selector: 'ngx-importar-arquivo-funcionario',
  templateUrl: './importar-arquivo-funcionario.component.html',
  styleUrls: ['./importar-arquivo-funcionario.component.scss'],
})
export class ImportarArquivoFuncionarioComponent implements OnInit {

  @ViewChild('fileInput', null) fileInput;
  @ViewChild('fileLabel', null) fileLabel;

  public idProdutoSelected = null;
  public productCardInfo = [];
  public hasVarejoAccepted: boolean = false;
  public saldoGlobalDisp = null;
  public saldoContaDisp = null;
  public saldoProx30diasDisp = null;
  public saldoParceladoDisp = null;
  public customLogin = null;
  public idProduct = null;
  public willDownload = false;
  public delimiter;
  public base64Output: string;
  public base64String = null;
  public requestRegisterEmployee: ISendMailRegisterEmployee = {} as ISendMailRegisterEmployee;
  public isDisabledSaveButton: boolean = true;

  constructor(
    private notifications: NotificationsService,
    private service: ImportarArquivoFuncionarioService,
    private router: Router,
    private commomService: CommonService,
    private spinnerService: NgxSpinnerService,
    private encriptyService: EncriptyUtilService,
    private dialogService: NbDialogService,
  ) { }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.idProdutoSelected = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-product-id'));

    this.searchBalances();

  }

  clearAll() {
    this.clearImport();
  }

  clearImport() {
    //Limpa informações do arquivo de importação    
    this.fileInput.nativeElement.value = null;
    this.fileLabel.nativeElement.innerText = '';
  }

  searchBalances() {
    //busca saldos disponíveis
    this.spinnerService.show();
    let params = new HttpParams();
    if (this.hasVarejoAccepted) {
      params = params.append('isReusoCorporativo', 'true');
    }

    this.service.buscarSaldoRecebiveis(null, (res) => {
      this.saldoProx30diasDisp = res.saldo30dias != null ? res.saldo30dias : 0;
      this.saldoParceladoDisp = res.saldoMaior30dias != null ? res.saldoMaior30dias : 0;

    }, null);

    this.service.buscaSaldoGlobal(params, (response) => {
      this.saldoGlobalDisp = response.saldoAtual;
      this.saldoContaDisp = response.saldoContaCorrente;
      this.fillProductCard();
    }, null);
  } // end searchBalances()

  fillProductCard() {
    this.commomService.buscaProdutos().subscribe(
      response => {
        const listProdutos: any = response;
        this.processProducts(listProdutos);
      },
      _error => {
        this.handleProductError();
      }
    );
  }

  processProducts(listProdutos: any) {
    const selectedProduct = listProdutos.find(product => product.produtoId == this.idProdutoSelected);

    if (selectedProduct) {
      this.setProductCardInfo(selectedProduct);
    }

    this.spinnerService.hide();
  }

  setProductCardInfo(product: any) {
    let productType: string;
    let icon: string;
    let description: string;

    switch (product.produtoDescricao) {
      case 'ADIANTA':
        productType = 'primary';
        icon = 'far fa-money-bill-alt';
        description = product.produtoDescricao;
        break;
      case 'PAGAMENTO':
        productType = 'danger';
        icon = 'fas fa-coins';
        description = 'PAGAMENTO';
        break;
      case 'ALIMENTACAO_BANDEIRADO':
        productType = 'danger';
        icon = 'fas fa-address-card';
        description = 'ALIMENTAÇÃO';
        break;
      case 'REFEICAO_BANDEIRADO':
        productType = 'info';
        icon = 'fas fa-id-card';
        description = 'REFEIÇÃO';
        break;
      case 'FLEXIVEL':
        productType = 'info';
        icon = 'fas fa-money-check';
        description = 'FLEXÍVEL';
        break;
      default:
        // Handle unknown product type
        return;
    }

    this.productCardInfo = [{
      'label': description,
      'descricao': product.produtoDescricao,
      'saldoAtual': product.saldoGlobalAtual == null ? 0 : product.saldoGlobalAtual,
      'icon': icon,
      'type': productType,
      'taxaDescricao': product.produtoDescricao,
    }];
  }

  handleProductError() {
    this.spinnerService.hide();
    this.notifications.error('Não foi possível carregar as informações de produto.');
  }

  convertToBase64(files: FileList) {
    this.isDisabledSaveButton = false;
    const file = files.item(0)
    const reader = new FileReader();
    this.fileLabel.nativeElement.innerText = file.name;

    reader.onload = () => {
      this.requestRegisterEmployee = {
        partnerId: 'valecard',
        filename: file.name,
        content: (reader.result as string).split('base64,')[1],
        subject: "CADASTRO_FUNCIONARIO_1VIA"
      }
    };
    reader.readAsDataURL(file);
  }

  saveEmployeeImport() {

    this.spinnerService.show();

    this.service.saveEmployeeImport(this.requestRegisterEmployee, () => {
      this.clearAll();
      this.searchBalances();
      this.spinnerService.hide();

    }, (error) => {
      this.clearAll();
      this.searchBalances();
      this.spinnerService.hide();
      this.notifications.error(error.message);
    });

  }

  openModal() {
    this.dialogService.open(ModalImportarArquivoFuncionarioComponent, {
      closeOnBackdropClick: false,
      closeOnEsc: false,
      context: {
        inputFile: this.requestRegisterEmployee,
      },
    }).onClose.subscribe(validacao => this.habillitarBotao(validacao))
  }

  habillitarBotao(value: boolean) {
    if ((value == false) || (value == undefined)) {
      this.notifications.warn('Operação cancelada.');
      this.fileInput.nativeElement.value = null;
      this.fileLabel.nativeElement.innerText = '';
      this.isDisabledSaveButton = true;
    } else if (value == true) {
      this.saveEmployeeImport();
    }
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  cancel() {
    this.clearAll();
    this.searchBalances();
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

}
